export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M18 8A6 6 0 006 8c0 3.5 3.6 8.2 5.2 10.1a1 1 0 001.6 0c1.6-2 5.2-6.6 5.2-10.1zm-8 0c0-1.1.9-2 2-2a2 2 0 11-2 2zM6 22a1 1 0 01-1-1c0-.6.5-1 1-1h12c.6 0 1 .4 1 1s-.4 1-1 1H6z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  }
};